import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Row, Col } from 'antd';



import FileUpload from './FileUpload';
import DemoFile from '../../assets/files/uplaod_diamond_demo_file.xlsx';

import { showNotification } from 'services/NotificationService';
import ListFooter from 'components/List/ListFooter';
import { uploadDiamondsExcel } from 'services/DiamondApi';
import { isArray, isEmpty } from 'util/utils';
import { useLoading } from 'util/hooks';

import '../../../../client/src/styles/settings.less';

const defaultValues = {
  type: '1',
  file: '',
  isEmailSend: false,
};

const validationSchema = Yup.object().shape({
  type: Yup.number()
    .required('Type is required'),
  file: Yup.mixed().test('file-required', 'File is required', (value) => {
    if (isArray(value)) return value.length > 0;
    return !isEmpty(value);
  }),
  isEmailSend: Yup.boolean().nullable(),
});

const UploadDiamond = () => {
  const [loading, startLoading, stopLoading] = useLoading(false);

  const handleDownloadDemo = () => {
    const link = document.createElement('a');
    link.href = DemoFile;
    link.download = 'diamond_demo_file.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const submitForm = React.useCallback(async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    startLoading();


    const [err, res] = await uploadDiamondsExcel(values);
    setSubmitting(false);
    stopLoading();

    if (!err) {
      showNotification(res);
    }
    resetForm();
  }, [startLoading, stopLoading]);

  return (
    <Formik initialValues={defaultValues} validateOnChange validationSchema={validationSchema} onSubmit={submitForm}>
      {({ handleBlur, setValues, touched, errors, values }) => (
        <Form>
          <div className="uploadDiamonds" >
            <div className="headeTitle" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2>Upload Diamonds</h2>
              <button
                type="button"
                className="commonButton"
                onClick={handleDownloadDemo}
                style={{ marginLeft: 'auto' }}
              >
                Download Demo File
              </button>
            </div>
            <Row type="flex" gutter={16}>
              <Col md={12} sm={12} span={6}>
                <FileUpload
                  className="d-flex align-items-center justify-content-center"
                  diamondUpload
                  fullWidth="width-auto"
                  name="file"
                  isValidate
                  accept="XLS,XLSX,CSV"
                  size="XLS,XLSX,CSV file allowed"
                  fileType="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  value={values?.file}
                  onChange={(file) => setValues((values) => ({ ...values, file: file || '' }))}
                  onBlur={handleBlur}
                  error={touched?.file && errors?.file}
                />
              </Col>
            </Row>
            <ListFooter className="homeSettingFooter">
              <span style={{ margin: 'auto' }}>
                <button className="commonButton mr-10" type="submit">
                  Save
                </button>
                <button className="commonOutLine" type="reset">
                  Reset
                </button>
              </span>
            </ListFooter>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UploadDiamond;
